export default __webpack_public_path__ + "static/375-04ef19d315961b2e98d50536b8468200.gif";